import {sbxCoreService} from "../Network";

const MODEL = "packing_type";

export function getPackingTypes() {
  return sbxCoreService.with(MODEL).loadAll();
}
